export default __webpack_public_path__ + "src/assets/images/banner_one.jpg?1cbe345b";